import css from 'styled-jsx/css'; // eslint-disable-line import/no-extraneous-dependencies

export default css.global`
  body {
    margin: 0;
    padding: 0;
  }

  .w-100 {
    position: relative;
    width: 100%;
    z-index: 2;
  }

  .text-center {
    text-align: center;
  }
`;
